<template>
  <el-dialog
    id="create-modal"
    class="form-modal"
    :visible.sync="visible"
    v-loading="modalProcessing"
    :fullscreen="true"
    :show-close="false"
    :modal="false"
  >
    <div id="create-modal-header" class="modal-header">
      <div class="modal-header-layout flex grid-6 align-center">
        <h1 class="modal-title col-2">{{ context }} a Phonebook</h1>
        <div class="modal-actions col-2">
          <el-button type="primary" @click="handleSubmit">{{
            context === 'Edit' ? 'Save' : context
          }}</el-button>
          <el-button type="default" class="hidden-xs-only" @click="handleClose"
            >Cancel</el-button
          >
          <el-button
            type="default"
            icon="el-icon-close"
            class="hidden-sm-and-up"
            @click="handleClose"
          ></el-button>
        </div>
      </div>
    </div>

    <el-form>
      <el-input v-model="form.name" placeholder="Name">
        <template slot="prefix">Name</template>
      </el-input>

      <contact-form
        :context="context"
        :contacts="contacts"
        :clearForm="clearForm"
        @change="form.contacts = $event"
      />
    </el-form>
  </el-dialog>
</template>

<script>
import ContactForm from "./contactForm";

export default {
  name: "PhonebooksForm",

  props: {
    context: { required: true },
    visible: { required: true },
    modalProcessing: { required: true },
    clearForm: { required: true },
    selectedRecord: { required: true },
  },

  components: {
    ContactForm,
  },

  data() {
    return {
      form: {
        tenantId: null,
        name: "",
        contacts: [],
      },
    };
  },

  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },

    contacts() {
      const { contacts = [] } = this.selectedRecord || {};
      return contacts;
    },
  },

  watch: {
    clearForm(value) {
      if (value) {
        this.clearFields();
      }
    },

    selectedRecord(record) {
      if (record) {
        const { name, contacts } = record;
        this.form.name = name;
        this.form.contacts = contacts;
      }
    },
  },

  methods: {
    handleSubmit() {
      this.form.tenantId = this.selectedTenant.id;

      if (this.context === "Create") {
        this.$emit("createOperation", this.form);
      }

      if (this.context == "Edit") {
        this.$emit("editOperation", this.form);
      }
    },

    handleClose() {
      this.$confirm("Cancel and Discard Unsaved Changes?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
      })
        .then(() => {
          this.$emit("modalClosed");
        })
        .catch(() => true);
    },

    clearFields() {
      this.form = {
        tenantId: null,
        name: "",
        contacts: [],
      };
    },
  },
};
</script>

<style lang="scss" scoped></style>
